import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import classNames from "classnames";

import RichTextBlock from "./RichTextBlock";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import "../styles/components/ProductCards.scss";

const Card = ({ image, copy }) => {
    const [expandedCopy, setExpandedCopy] = useState(false);

    return (
        <div
            className={classNames("product-card p-3 p-md-4", {
                "full-copy": expandedCopy,
            })}
        >
            <GatsbyImageWithSVGSupport
                className="ratio ratio-1x1 image mb-4"
                image={image}
            />
            <RichTextBlock truncate={expandedCopy ? null : 3} content={copy} />
            <div>
                <Button
                    className="text-start p-0"
                    variant="link"
                    onClick={() => setExpandedCopy(!expandedCopy)}
                >
                    {expandedCopy ? "Show Less" : "Show More"}
                </Button>
            </div>
        </div>
    );
};

const ProductCards = ({ cards }) => {
    if (!cards.length) return null;

    return (
        <Row>
            {cards.map(card => (
                <Col key={card.id} className="my-3" md={6}>
                    <Card image={card.image} copy={card.copy} />
                </Col>
            ))}
        </Row>
    );
};

ProductCards.propTypes = {
    cards: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            copy: PropTypes.shape({ raw: PropTypes.string }),
            image: PropTypes.shape({ gatsbyImageData: PropTypes.object }),
        })
    ),
};

export default ProductCards;
